import e from "./index52.js";
//#region ../../node_modules/.pnpm/@mui+utils@7.3.9_@types+react@19.2.14_react@19.2.4/node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var t = {
	active: "active",
	checked: "checked",
	completed: "completed",
	disabled: "disabled",
	error: "error",
	expanded: "expanded",
	focused: "focused",
	focusVisible: "focusVisible",
	open: "open",
	readOnly: "readOnly",
	required: "required",
	selected: "selected"
};
function n(n, r, i = "Mui") {
	let a = t[r];
	return a ? `${i}-${a}` : `${e.generate(n)}-${r}`;
}
//#endregion
export { n as default };

//# sourceMappingURL=index55.js.map